<template>
  <!-- 运费追加提示 start -->
  <el-dialog title="追加运费重要提示" :visible.sync="dialogFeeAdd">
    <div class="dialog-fee-con">
      <iframe
        src="https://static.sijibao.com/webServer/feeadd.html"
        frameborder="0"
        style="width: 100%; height: 400px"
      ></iframe>
    </div>
    <div class="dialog-fee-btn-con">
      <el-button @click="dialogFeeAdd = false">取消</el-button>
      <el-button type="primary" @click="dialogFeeAddClick">确认</el-button>
    </div>
  </el-dialog>
  <!-- 运费追加提示 end -->
</template>
<script>
export default {
  data() {
    return {
      dialogFeeAdd: false
    };
  },
  methods: {
    dialogFeeAddClick() {
      this.$emit('dialogFeeAddClick');
    },
    openDia() {
      this.dialogFeeAdd = true;
    },
    closeDia() {
      this.dialogFeeAdd = false;
    }
  }
};
</script>
